import React from 'react';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import PointsOfInterestListFilters from './PointsOfInterestListFilters';
import PropTypes from 'prop-types';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deletePointOfInterest } from 'store/actions/pointsofinterest/deletePointsOfInterest';
import { fetchPointsOfInterest } from 'store/actions/pointsofinterest/fetchPointsOfInterest';

const PointsOfInterestList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <PointsOfInterestListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchPointsOfInterest }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table>
                    <TextField
                        column={ {
                            sortable: true,
                        } }
                        label='resources.points_of_interest.fields.name'
                        source='name'
                    />

                    <TextField
                        column={ {
                            sortable: false,
                        } }
                        label='resources.points_of_interest.fields.city'
                        source='city'
                    />

                    <TextField
                        column={ {
                            sortable: false,
                        } }
                        label='resources.points_of_interest.fields.country'
                        source='country_iso2'
                        valueTranslationPrefix='countries'
                    />

                    <TextField
                        column={ {
                            sortable: false,
                        } }
                        label='resources.points_of_interest.fields.type'
                        source='type'
                        valueTranslationPrefix='resources.points_of_interest.types'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deletePointOfInterest } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

PointsOfInterestList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(PointsOfInterestList);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/list/PointsOfInterestList.js